/* eslint jsx-a11y/label-has-associated-control: ["error", { "assert": "nesting" }] */
import { useState } from "react";
import { AffiliateOperation } from "../../interfaces/affiliate";

export function PointsClawbackPanel({
  disabled,
  run,
}: {
  disabled: boolean;
  run: (
    operation: AffiliateOperation,
    payload: Record<string, unknown>
  ) => Promise<boolean>;
}) {
  const [wallet, setWallet] = useState("");
  const [points, setPoints] = useState("");
  const [reason, setReason] = useState("");
  const [reviewed, setReviewed] = useState(false);
  return (
    <section>
      <h2>Claw back available points</h2>
      <p>
        Removes only unspent, vested and unexpired points. Funded trader
        budgets, pending points and cash commissions are unchanged. Use the
        grant form below to add welcome points or a boost.
      </p>
      <form
        onSubmit={async (event) => {
          event.preventDefault();
          if (disabled || !reviewed || !/[1-9]/.test(points)) return;
          if (
            await run("clawback_points", {
              affiliate: wallet.trim(),
              points,
              reason: reason.trim(),
            })
          ) {
            setPoints("");
            setReason("");
            setReviewed(false);
          }
        }}
      >
        <fieldset disabled={disabled}>
          <label>
            Points clawback wallet
            <input
              required
              pattern="0x[a-fA-F0-9]{40}"
              value={wallet}
              onChange={(event) => {
                setWallet(event.target.value);
                setReviewed(false);
              }}
            />
          </label>
          <label>
            Points to remove
            <input
              required
              inputMode="decimal"
              pattern="[0-9]+(\.[0-9]+)?"
              value={points}
              onChange={(event) => {
                setPoints(event.target.value);
                setReviewed(false);
              }}
            />
          </label>
          <label>
            Points clawback reason
            <input
              required
              maxLength={1000}
              value={reason}
              onChange={(event) => {
                setReason(event.target.value);
                setReviewed(false);
              }}
            />
          </label>
          <label>
            I reviewed this points-only clawback
            <input
              type="checkbox"
              required
              checked={reviewed}
              onChange={(event) => setReviewed(event.target.checked)}
            />
          </label>
          <button
            type="submit"
            disabled={!reviewed || !/[1-9]/.test(points) || !reason.trim()}
          >
            Claw back points
          </button>
        </fieldset>
      </form>
    </section>
  );
}
